module.exports = __webpack_public_path__ + "img/grid_blue.308b42cb.svg";